import * as React from 'react';
import type { WrappedFieldArrayProps } from 'redux-form';

import type { AccountViewModel } from 'ab-viewModels/account.viewModel';

import { NotificationPriority } from '@acceligentllc/shared/enums/notificationPriority';

import AccountItem from './AccountItem';

export interface OwnProps {
	onExcludeAccount: (userGroupName: string, accountId: number) => void;
	userGroupName: string;
	notificationPriority: NotificationPriority;
}

type Props = OwnProps & WrappedFieldArrayProps<AccountViewModel>;

const Accounts: React.FC<Props> = (props) => {
	const { fields, onExcludeAccount, userGroupName, notificationPriority } = props;

	const handleExcludeAccount = React.useCallback((index: number, accountId: number) => {
		fields.remove(index);
		onExcludeAccount(userGroupName, accountId);
	}, [fields, onExcludeAccount, userGroupName]);

	const renderItem = React.useCallback((_accountFieldName, _index) => {
		const _account = fields.get(_index);
		const hasEmail = !!_account.email;
		const hasPhoneNumber = !!_account.phoneNumber;

		const willReceiveNotification =
			(notificationPriority === NotificationPriority.EMAIL_ONLY && hasEmail)
			|| (notificationPriority === NotificationPriority.SMS_ONLY && hasPhoneNumber)
			|| [NotificationPriority.EMAIL_FIRST, NotificationPriority.SMS_FIRST, NotificationPriority.SEND_BOTH].includes(notificationPriority)
			&& (hasEmail || hasPhoneNumber);

		return (
			<AccountItem
				account={_account}
				hasEmail={hasEmail}
				index={_index}
				key={_account.uniqueId}
				onExcludeAccount={handleExcludeAccount}
				willReceiveNotification={willReceiveNotification}
			/>
		);
	}, [fields, handleExcludeAccount, notificationPriority]);

	return fields.map(renderItem);
};

export default React.memo(Accounts);
